import axios from 'axios'
import { useAuthStore } from '../stores/authStore'

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || 'http://localhost:3001/api/v1',
  timeout: 15000
})

let renovacaoEmAndamento = null

api.interceptors.request.use(config => {
  const token = useAuthStore.getState().accessToken

  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }

  return config
})

const renovarSessao = async () => {
  const refreshToken = useAuthStore.getState().refreshToken

  if (!refreshToken) throw new Error('Sessão sem refresh token')

  const { data } = await axios.post(
    `${api.defaults.baseURL}/auth/refresh`,
    { refreshToken },
    { timeout: api.defaults.timeout }
  )

  useAuthStore.getState().renovarTokens(data)
  return data.accessToken
}

api.interceptors.response.use(
  response => response,
  async error => {
    const requestOriginal = error.config
    const tokenExpirou = error.response?.status === 401 &&
      error.response?.data?.message === 'Token expirado'

    if (!requestOriginal || requestOriginal._sessaoRenovada || !tokenExpirou) {
      return Promise.reject(error)
    }

    requestOriginal._sessaoRenovada = true

    try {
      if (!renovacaoEmAndamento) {
        renovacaoEmAndamento = renovarSessao().finally(() => {
          renovacaoEmAndamento = null
        })
      }

      const accessToken = await renovacaoEmAndamento
      requestOriginal.headers.Authorization = `Bearer ${accessToken}`
      return api(requestOriginal)
    } catch (refreshError) {
      useAuthStore.getState().logout()
      return Promise.reject(refreshError)
    }
  }
)

export const getApiError = (error, fallback = 'Não foi possível concluir a solicitação.') => {
  const data = error.response?.data

  if (data?.message) return data.message
  if (Array.isArray(data?.errors)) {
    return data.errors.map(item => item.msg).filter(Boolean).join(' ')
  }

  if (error.code === 'ECONNABORTED') {
    return 'A API demorou para responder. Tente novamente.'
  }

  return fallback
}

export default api
